import { createI18n } from 'vue-i18n';
import { messages } from '../../translation';
import { Languages } from '@/common/types';

const i18n = createI18n({
  locale: Languages['en-us'],
  legacy: false,
  fallbackLocale: Languages['en-us'],
  messages,
  missingWarn: false,
  fallbackWarn: false
});

export const translate = i18n.global.t.bind(i18n.global);

export default i18n;
